var path = 'areas/shared/views/selector/select-template.html';
var html = "<div> <ui-select ng-if=vm.showControl() ng-model=vm.selected ng-change=vm.onChange() search-enabled=true append-to-body=true> <ui-select-match placeholder={{vm.placeholder}} allow-clear=true> </ui-select-match> <ui-select-choices repeat=\"item.Id as item in vm.available | filter: $select.search\"> <ng-include src=::vm.choiceTemplate></ng-include> </ui-select-choices> </ui-select> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/select-template.html
// module id = 577095480565300
// module chunks = 1